import { HttpResult } from 'widgets-for-react'

export const paginationApi = async (fetchUrl: string): Promise<HttpResult<number>> => {
  const res = await fetch(fetchUrl)

  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status,
    }

  var data = await res.json()

  return {
    kind: 'result',
    value: data,
    status: 200,
  }
}
